import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useForm } from 'antd/lib/form/Form';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Col,
  Row,
  Form,
  Tabs,
  Input,
  DatePicker,
  notification,
  Tag,
  InputNumber,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import DF from 'DisplayFramework';
import { PurchaseOrder } from 'services/purchaseOrder';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButton';
import {
  createGuaranty,
  getConGuaranty,
  getGuarantyByID,
  updateGuaranty,
} from 'services/guaranty';
import { shouldUpdateCompare, toDatePickerDate } from 'utils/utils2';
import Button from 'components/Button';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import Beneficiary from './beneficiaryList';
import AssociatedContract from './associatedContractList';
import ThirdPartyInput from 'components/ThirdPartyInput';
import Title from 'components/Title';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';
import GetLabel from 'DisplayFramework/components/GetLabel';
import TextArea from 'antd/lib/input/TextArea';
import InputCurrency from 'components/InputCurrency';
import { toCurrency } from 'utils/utils';
import moment from 'moment';
import Value from 'components/Value';
import { CheckCircleOutlined, SyncOutlined } from '@ant-design/icons';
import IActions from 'icons/IActions';
import PArGuarCodeSelect from 'components/ParGuarCodeSelect';
import GuarantyValue from './guarantyValue';
import Address from 'components/address';
import { isNil } from 'lodash';
import WizardTabs from 'components/WizardTabs';
import { getMyWizards } from 'services/workflow';
import { getThirdPartyById } from 'services/thirdParty';

const fieldName = 'guaranty';
const { TabPane } = Tabs;

type ThirdPartyDetailProps = {
  guarId?: string;
  iscreate?: boolean;
};

const GuarantDetail = (props: ThirdPartyDetailProps) => {
  const { guarId, iscreate } = props;

  const { idOrCreate } = useParams<{ idOrCreate: string }>();

  const isCreate = idOrCreate === 'create';
  let id: any = !isCreate ? Number(idOrCreate) : undefined;

  const getId = () => {
    return guarId ? (guarId === '0' ? 'create' : guarId) : id;
  };

  id = getId();

  const {
    data: Guaranty,
    refetch: refetch1,
    isFetched,
  } = useQuery(
    [`getGuarantyByID`, { guarid: Number(id) }],
    () => getGuarantyByID({ guarid: Number(id) }).then((res) => res.data || {}),
    { enabled: !isNil(id) && !isNaN(Number(id)) && !!id }
  );
  const { data: ConGuarantyList, refetch: ref1 } = useQuery(
    ['getConGuaranty', { guarid: Number(id) }],
    () => getConGuaranty({ guarid: Number(id) }).then((res) => res.list || []),
    {
      enabled: !!id,
    }
  );
  const navigate = useNavigate();
  const { data: wizData } = useQuery(['getMyWizards'], () =>
    getMyWizards({
      entity: 'GUARANTY',
    }).then((res) => res.data)
  );
  const [currcode, setCurrcode] = useState(
    localStorage.getItem('currcode') ?? ''
  );

  // eslint-disable-next-line no-unused-vars
  const [Params, setParams] = useState<any>({
    tpreference: Guaranty?.tpidbeneficiary,
    tpname: 'TP',
  });
  const [form] = useForm();

  const tabPosition = localStorage.getItem('tabposition') ?? 'left';

  useEffect(() => {
    if (Guaranty) {
      form.resetFields();
      setParams({ tpidbeneficiary: Guaranty.tpidbeneficiary });
      form.setFieldsValue({
        ...Guaranty,
        created_at: toDatePickerDate(Guaranty?.created_at),
        guarreceptiondate: toDatePickerDate(Guaranty?.guarreceptiondate),
        guarsignaturedate: toDatePickerDate(Guaranty?.guarsignaturedate),
        guarstatusdate: Guaranty?.guarstatusdate,
        tpidguarantor: {
          tpid: Guaranty.tpidguarantor,
          tpreference: Guaranty.guarreference,
          tpname: Guaranty.guarantorname,
        },
        tpidbeneficiary: {
          tpid: Guaranty.tpidbeneficiary,
          tpreference: Guaranty.beneficiaryreference,
          tpname: Guaranty.beneficiaryname,
        },
      });
      setCurrcode(Guaranty?.currcode);
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, Guaranty, isFetched]);
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

  const submit = () => {
    setLoadingBtn(true);
    let val = {
      ...form.getFieldsValue(),
      tpidguarantor: form.getFieldValue('tpidguarantor')?.tpid,
      tpidbeneficiary: form.getFieldValue('tpidguarantor')?.tpid,
      beneficiaryname: form.getFieldValue('tpidguarantor')?.tpname,
      beneficiaryreference: form.getFieldValue('tpidguarantor')?.tpreference,
      guarantorname: form.getFieldValue('tpidguarantor')?.tpname,
      guarantorreference: form.getFieldValue('tpidguarantor')?.tpreference,
      guarsignaturedate:form.getFieldValue('guarsignaturedate'),
    };

    isCreate
      ? createGuaranty({
          guarRequest: {
            ...val,
            guarsignaturedate:val?.guarsignaturedate??moment().format('YYYY-MM-DD'),
          },
        })
          .then((response) => {
            if (response.code === '200') {
              notification.success({
                message: response.message,
              });
              setLoadingBtn(false);
              navigate(`/guaranty/${Number(response.data.guarid)}`);
            }
          })
          .catch(() => {
            setLoadingBtn(false);
          })
      : updateGuaranty({
          guarid: form.getFieldValue('guarid'),
          guarRequest: val,
        })
          .then((response) => {
            if (response.code === '200') {
              notification.success({
                message: response.message,
              });
              setLoadingBtn(false);
              refetch1();
            }
          })
          .catch(() => {
            setLoadingBtn(false);
          });
  };

  const refetch = () => {
    ref1();
  };

  const initialValues = {
    guartype: '',
    tpidguarantor: null,
    tpidbeneficiary: 0,
    guarexternalref: '',
    guarrank: 0,
    guardescription: '',
    guaradrstreet1: '',
    guaradrstreet2: '',
    guardrzipcode: '',
    guaradrcity: '',
    guaradrregion: '',
    guaradrcountry: '',
    guarusageamount: 0,
    // currcode: '',
    guaramount: null,
    statuslabel: 'Initial',
  };
  const colorTag = (status: string) => {
    if (isCreate) return 'white';
    if (status === 'ACTIVE') {
      return 'success';
    } else if (status === 'INIT') {
      return 'default';
    } else if (status === 'INPROG') {
      return 'warning';
    } else if (status === 'CANCEL') {
      return 'error';
    } else if (status === 'TERMINATED') {
      return 'geekblue';
    }
    return '';
  };
  const tabgeneralguaranty = (
    <div style={{ backgroundColor: '#ffff', padding: 5 }}>
      <div style={{ padding: 5, background: 'white' }}>
        <div>
          <Row>
            <Col span={24}>
              <Row gutter={16}>&nbsp;</Row>
              <Row gutter={20} style={{ marginLeft: 35,gap:10 }}>
                <FormInput
                  labelAlign="left"
                  col
                  xs={24}
                  lg={5}
                  name="guarreference"
                >
                  <Input disabled />
                </FormInput>

                <FormInput
                  labelAlign="left"
                  col
                  xs={24}
                  lg={5}
                  name="guartype"
                  rules={[{ required: true }]}
                >
                  <ParListSelect
                    parcode="GUARTYPE"
                    onChange={(e) => form.setFieldsValue({ guarcode: '' })}
                  />
                </FormInput>
                <Form.Item
                  shouldUpdate={shouldUpdateCompare('guartype')}
                  noStyle
                >
                  {({ getFieldValue }) => (
                    <FormInput
                      labelAlign="left"
                      col
                      xs={24}
                      lg={5}
                      name="guarcode"
                    >
                      <PArGuarCodeSelect guartype={getFieldValue('guartype')} />
                    </FormInput>
                  )}
                </Form.Item>
                <FormInput
                  labelAlign="left"
                  col
                  xs={24}
                  lg={3}
                  name="statuslabel"
                >
                  <Tag
                    icon={
                      (form.getFieldValue('guarstatus') === 'ACTIVE' && (
                        <CheckCircleOutlined />
                      )) ||
                      (form.getFieldValue('guarstatus') === 'INPROG' && (
                        <SyncOutlined spin />
                      ))
                    }
                    color={colorTag(form.getFieldValue('guarstatus'))}
                  >
                    {form.getFieldValue('statuslabel')}
                  </Tag>
                </FormInput>
                {!isCreate && (
                  <FormInput
                    labelAlign="left"
                    col
                    xs={24}
                    lg={5}
                    name="guarstatusdate"
                  >
                    <Value
                      formatter={(value) => moment(value).format('YYYY-MM-DD')}
                    />
                  </FormInput>
                )}
                <Col span={5}></Col>
              </Row>
              <Col span={24}>
                <Row gutter={[50, 15]} style={{ marginLeft: 20 }}>
                  <UtinaCard
                    level={5}
                    comcode="guaranties_info"
                    style={{
                      color: '#000',
                      marginLeft: 20,
                      paddingTop: 20,
                    }}
                    lg={8}
                  >
                    <Row gutter={16}>&nbsp;</Row>
                    <Row gutter={20}>
                      <Col lg={24}>
                        <FormInput
                          name="tpidguarantor"
                          rules={[{ required: true }]}
                        >
                          <ThirdPartyInput
                            isCreate={false}
                            role="GUAR"
                            onSelected={async (e) => {
                              form.setFieldsValue({ guaradrstreet1: e });
                              await getThirdPartyById({
                                tpid: Number(e.tpid),
                              }).then((res) => {
                                if (res.code === '200') {
                                  form.setFieldsValue({
                                    guaradrstreet1:res.data.address.tpmainadrstreet1,
                                    guaradrstreet2:res.data.address.tpmainadrstreet2,
                                    guaradrcountry:res.data.address.tpmainadrcountry,
                                    guaradrregion:res.data.address.tpmainadrregion,
                                    guaradrcity:res.data.address.tpmainadrcity,
                                    guardrzipcode:res.data.address.tpmainadrzipcode,
                                  });
                                }
                              });
                            }}
                          />
                        </FormInput>
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      <Col lg={12}>
                        <FormInput
                          name="guarexternalref"
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </FormInput>
                      </Col>
                      <Col lg={12}>
                        <FormInput name="guarrank" rules={[{ required: true }]}>
                          <InputNumber min={0} />
                        </FormInput>
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      <Col lg={12}>
                        <FormInput
                          name="guarreceptiondate"
                          rules={[{ required: true }]}
                        >
                          <DatePicker />
                        </FormInput>
                      </Col>
                      <Col lg={12}>
                        <FormInput name="guarsignaturedate">
                          <DatePicker defaultValue={moment()}/>
                        </FormInput>
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      <Col lg={24}>
                        <FormInput name="guardescription">
                          <TextArea rows={2} />
                        </FormInput>
                      </Col>
                    </Row>
                  </UtinaCard>
                  <UtinaCard
                    level={5}
                    comcode="adress"
                    style={{ color: '#000', marginLeft: 30 }}
                    lg={8}
                  >
                    <Row gutter={16}>&nbsp;</Row>
                    <Row gutter={20}>
                      <Col lg={24}>
                        <FormInput name="guaradrstreet1">
                          <Input />
                        </FormInput>
                      </Col>
                      <Col lg={24}>
                        <FormInput name="guaradrstreet2">
                          <Input />
                        </FormInput>
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      <Address
                        colU={12}
                        form={form}
                        paysField="guaradrcountry"
                        regionField="guaradrregion"
                        villeField="guaradrcity"
                        codePostalField="guardrzipcode"
                        hideRegionGlobal
                      />
                      {/* <Col lg={12}>
                      <FormInput name="guardrzipcode">
                        <Input />
                      </FormInput>
                    </Col>
                    <Col lg={12}>
                      <FormInput name="guaradrcity">
                        <Input />
                      </FormInput>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col lg={12}>
                      <FormInput name="guaradrregion">
                        <Input />
                      </FormInput>
                    </Col>
                    <Col lg={12}>
                      <FormInput name="guaradrcountry">
                        <Input />
                      </FormInput>
                    </Col> */}
                    </Row>
                  </UtinaCard>
                  <UtinaCard
                    level={5}
                    comcode="financialInformation"
                    style={{ color: '#000', marginLeft: 30 }}
                    lg={5}
                  >
                    <Row gutter={16}>&nbsp;</Row>
                    <Col lg={24}>
                      <FormInput name="currcode" rules={[{ required: true }]}>
                        <ParListSelect
                          onChange={(e) => {
                            setCurrcode(e);
                          }}
                          parcode="CURRENCY"
                          disabled={
                            !isCreate &&
                            form.getFieldValue('guarstatus') !== 'INIT'
                          }
                        />
                      </FormInput>
                    </Col>
                    <Col lg={24}>
                      <FormInput
                        name="guaramount"
                        rules={[{ required: true }]}
                        style={{ width: '100%' }}
                      >
                        <InputCurrency
                          col
                          md={24}
                          style={{ width: '100% !important' }}
                          currcode={
                            isCreate ? form.getFieldValue('currcode') : currcode
                          }
                          disabled={
                            !isCreate &&
                            form.getFieldValue('guarstatus') !== 'INIT'
                          }
                        />
                      </FormInput>
                    </Col>

                    <Col lg={24}>
                      <FormInput
                        style={{ fontWeight: 'bold' }}
                        name="guarusageamount"
                      >
                        <Value
                          formatter={(value) =>
                            toCurrency(
                              value,
                              isCreate
                                ? form.getFieldValue('currcode')
                                : currcode
                            )
                          }
                        />
                      </FormInput>
                    </Col>

                    <Col lg={24}>
                      <FormInput
                        name="guarremainamount"
                        style={{
                          fontWeight: 'bold',
                          color:
                            form.getFieldValue('guarremainamount') < 0
                              ? 'red'
                              : 'black',
                        }}
                      >
                        <Value
                          formatter={(value) =>
                            toCurrency(
                              value,
                              isCreate
                                ? form.getFieldValue('currcode')
                                : currcode
                            )
                          }
                        />
                      </FormInput>
                    </Col>
                  </UtinaCard>
                </Row>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
  const tabbeneficiary = (
    <div style={{ backgroundColor: '#ffff', padding: 5 }}>
      <Form.Item
        noStyle
        shouldUpdate={(prevValue: PurchaseOrder, nextValue: PurchaseOrder) => {
          return (
            prevValue?.purOrderLines?.length !==
            nextValue?.purOrderLines?.length
          );
        }}
      >
        <Beneficiary
          hideTitle
          iscreate={iscreate}
          guarId={id}
          refetch1={() => {
            refetch();
          }}
          guarreceptiondate={form.getFieldValue('guarreceptiondate')}
          guaramount={Number(form.getFieldValue('guaramount'))}
          currcode={form.getFieldValue('currcode')}
        />
      </Form.Item>
    </div>
  );
  const tabassociatedcontracts = (
    <div style={{ backgroundColor: '#ffff', padding: 5 }}>
      <Form.Item
        noStyle
        shouldUpdate={(prevValue: PurchaseOrder, nextValue: PurchaseOrder) => {
          return (
            prevValue?.purOrderLines?.length !==
            nextValue?.purOrderLines?.length
          );
        }}
      >
        <AssociatedContract
          data={ConGuarantyList}
          refetch={refetch1}
          currcode={form.getFieldValue('currcode')}
        />
      </Form.Item>
    </div>
  );
  const tabguarantyvalue = (
    <div style={{ backgroundColor: '#ffff', padding: 5 }}>
      <GuarantyValue guarId={Number(id)} />
    </div>
  );

  return (
    <DF.Provider pagcode="guarantydetail">
      <Form
        form={form}
        onFinish={submit}
        layout="vertical"
        initialValues={initialValues}
      >
        <div className="card-container">
          <Row style={{ fontSize: '14px', fontWeight: 'bold' }}>
            <Col span={19}>
              <ArrowLeftOutlined
                onClick={() => {
                  navigate(`/guaranty`);
                }}
                style={{ float: 'left', margin: '0px 5px', fontSize: 'larger' }}
              />
              {Guaranty ? (
                <>
                  <GetLabel label="Guaranty" />
                  {' - ' +
                    Guaranty.guarreference +
                    ' - ' +
                    Guaranty.guarantorname}{' '}
                </>
              ) : (
                <Title level={4} comcode="NewGuaranty"></Title>
              )}
            </Col>
            <Col span={5}>
              {tabPosition === 'left' ? (
                <Row gutter={2} justify="end">
                  {(iscreate ||
                    iscreate === undefined ||
                    form.getFieldValue('guarstatus') === 'INIT') && (
                    <>
                      <Col span={10}>
                        {Number(id) ? (
                          <TasksListPopover
                            entityId={Number(id)}
                            entityName="GUARANTY"
                            entityReference={Guaranty?.guarreference}
                            title={
                              Guaranty?.guarreference +
                              ' - ' +
                              Guaranty?.beneficiaryname
                            }
                            onClose={() => {
                              refetch1();
                            }}
                          >
                            <Button comcode="actions" icon={<IActions />} />
                          </TasksListPopover>
                        ) : null}
                      </Col>
                      <Col span={13}>
                        <SaveButton
                          comcode="save"
                          custom={{ height: 52 }}
                          loading={loadingBtn}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              ) : null}
            </Col>
          </Row>
          <WizardTabs
            entity="GUARANTY"
            entityid={id}
            taskid={
              !isCreate
                ? wizData?.taskidDisplay ?? 0
                : wizData?.taskidCreate ?? 0
            }
            defaultTabs={['tabgeneralguaranty']}
            tabs={{
              tabgeneralguaranty: tabgeneralguaranty,
              tabbeneficiary: tabbeneficiary,
              tabassociatedcontracts: tabassociatedcontracts,
              tabguarantyvalue: tabguarantyvalue,
            }}
            disabled={
              isCreate && [
                tabbeneficiary,
                tabassociatedcontracts,
                tabguarantyvalue,
              ]
            }
            tabBarExtraContent={tabPosition === 'top' && null}
          />
          <Tabs
            defaultActiveKey="1"
            tabPosition="left"
            tabBarExtraContent={
              tabPosition === 'top' ?? (
                <>
                  <TasksListPopover
                    entityName="GUARANTY"
                    entityReference={Guaranty?.guarreference}
                    title={
                      Guaranty?.guarreference +
                      ' - ' +
                      Guaranty?.beneficiaryname
                    }
                    onClose={() => {
                      refetch1();
                    }}
                    entityId={Number(id)}
                  >
                    <Button comcode="actions" />
                  </TasksListPopover>{' '}
                  <SaveButton
                    htmlType="submit"
                    comcode="save"
                    loading={loadingBtn}
                  />
                </>
              )
            }
          ></Tabs>
        </div>
      </Form>
    </DF.Provider>
  );
};

export default GuarantDetail;
